import React from 'react';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import OrderNotificationsLayout from './orderNotificationsLayout';

const styles={
    headLine:{
        fontSize: 30,
        fontWeight:500
    }
};

class OrderNotifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div className='container-div'>
                <ContentGrid
                    content={
                        <Card
                            header={'Order Notifications'}
                            CardHeaderProps={{
                                classes: {
                                    title:classes.headLine
                                }
                            }}
                            content={
                                <OrderNotificationsLayout/>
                            }
                            CardContentProps={{
                                style: {borderTop: '1px solid #ddd'}
                            }}
                        />
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.loginResponse
    }
};
export default connect(mapStateToProps, null)(withStyles(styles)(OrderNotifications));